(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["athilo-mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const trigger = event.target.closest('.athilo-nav__trigger');
    document.querySelectorAll('.athilo-nav__category[open]').forEach(function(category) {
      if (trigger && category === trigger.parentElement) return;
      if (!trigger && category.contains(event.target)) return;
      category.open = false;
    });
  });
  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.athilo-nav__category[open]').forEach(function(category) {
      category.open = false;
      category.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
